<template>
  <RadioButtonList required v-model="selection">
    <option :value="0">{{ $t('vatInfo.subjectToVatDescription') }}</option>
    <option :value="1">{{ $t('vatInfo.townWithoutSocialCharacterDescription') }}</option>
    <option :value="2">{{ $t('vatInfo.socialHousingDescription') }}</option>
    <option :value="3">{{ $t('vatInfo.embassyDescription') }}</option>
    <option :value="4">{{ $t('vatInfo.townWithSocialCharacterDescription') }}</option>
    <option :value="5">{{ $t('vatInfo.housingForDisabledDescription') }}</option>
    <option :value="6">{{ $t('vatInfo.restHouseDescription') }}</option>
    <option :value="7">{{ $t('vatInfo.schoolDescription') }}</option>
  </RadioButtonList>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { CompanyVatInfoFirstStepSelection } from '@/models'

@Component({
  name: 'company-first-vat-info-selector'
})
export default class CompanyFirstVatInfoSelector extends Vue {
  //#region [Property]
  @Prop({ type: Number, required: false }) public readonly value!: CompanyVatInfoFirstStepSelection | null
  //#endregion

  //#region [Computed]
  public get selection(): CompanyVatInfoFirstStepSelection | null {
    return this.value
  }

  public set selection(val: CompanyVatInfoFirstStepSelection | null) {
    this.change(val)
  }
  //#endregion

  //#region [Emit]
  @Emit('input')
  public change(value: CompanyVatInfoFirstStepSelection | null): CompanyVatInfoFirstStepSelection | null {
    return value
  }
  //#endregion
}
</script>